import { render, staticRenderFns } from "./AdminCertificate.vue?vue&type=template&id=6912b761&scoped=true&"
import script from "./AdminCertificate.vue?vue&type=script&lang=js&"
export * from "./AdminCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6912b761",
  null
  
)

export default component.exports